import { appConfig } from '~/appConfig';
import AbstractLocalRepository from '~base/AbstractLocalRepository';

export default class RefreshLocalRepository extends AbstractLocalRepository {
  tableName(): string {
    return appConfig.refreshTokenStorageKey;
  }
}
